import Vue from 'vue'
import VueResource from 'vue-resource'
import swal from 'sweetalert2'
import config from './config'
import store from './store'
import Cookies from 'js-cookie'
import i18n from './i18n'
// import router from './router'

// Migration stuff
import { hasPermission } from './utils'

const EndPoint = config.baseUrl + '/api/'

const EndPointREP = config.repUrl

Vue.use(VueResource)
Vue.http.interceptors.push(function (request, next) {
  if (!request.url.endsWith('oauth2/token')) {
    // SUPER IMPORTANT STEP HERE
    // the ...oauth2/token is used to get the togens from cognito of a user that
    // is logged using SAML. This API doesnt like to receive not expected headers

    if (store.state.auth && !!store.state.auth.authorization) {
      request.headers.set('Authorization', store.state.auth.authorization)
    } else {
      request.headers.set('Authorization', Cookies.get('Authorization'))
    }

    if (store.state.auth.accessToken || Cookies.get('accessToken')) {
      request.headers.set('X-PontoTel-Authorization', store.state.auth.accessToken || Cookies.get('accessToken'))
      request.headers.set('X-PontoTel-UP', store.state.auth.userPoolId || Cookies.get('userPoolId'))
      request.headers.set('X-PontoTel-DI', store.state.auth.userPoolWebClientId || Cookies.get('userPoolWebClientId'))
    }
  }

  if (request.url.includes('http://localhost:8000') || (EndPointREP !== '' && request.url.includes(EndPointREP))) {
    request.headers.set('CMP', store.state.userInfo.compMan.id)
  }
  next()
})

export async function retryRequest (api, params, data = undefined, maxRetries = 3) {
  // Back can cry some times with so many requests.
  // Use this function to retry 3 times a request.
  // Usage: retryRequest(API.timesheet.post, {load: 'lines'}, {})

  params = params ? Object.freeze({...params}) : undefined
  data = data ? Object.freeze({...data}) : undefined

  return new Promise(async function (resolve, reject) {
    let triesCounter = 0
    let lastError

    while (triesCounter < maxRetries) {
      triesCounter = triesCounter + 1
      try {
        const result = await api(params, data)
        resolve(result)
        return
      } catch (err) {
        lastError = err
      }
    }
    reject(lastError)
  })
}

export const API = {
  login: Vue.resource(EndPoint + 'auth'),

  info: Vue.resource(EndPoint + 'personal/short'),

  notification: Vue.resource(EndPoint + 'notification'),

  forgotPassword: Vue.resource(EndPoint + 'esqueci-minha-senha{/email}'),

  applyAll: Vue.resource(EndPoint + 'apply-all'),

  holiday: Vue.resource(EndPoint + 'holiday-calendar{/id}'),

  frontVisual: Vue.resource(EndPoint + 'custom-visual{/userId}'), // -> api that returns the styles and layout

  logout: Vue.resource(EndPoint + 'auth-logout'),

  userFirebaseToken: Vue.resource(EndPoint + 'user/firebase-token{/entity}{/id}'),

  redirectSSORoute: Vue.resource(EndPoint + 'redirect-sso-route{/compManId}'), // -> returns route for logout

  getAuthUserPool: Vue.resource(EndPoint + 'auth-user-pool/frontend'),

  compManAcceptTerms: Vue.resource(EndPoint + 'accept-terms{/compManId}'),

  compManDetail: Vue.resource(EndPoint + 'compman-detail{/compManId}{?fields}'),

  legacyLogout: Vue.resource(EndPoint + 'logout'),

  employee: Vue.resource(EndPoint + 'employee{/id}'),

  approvals: Vue.resource(EndPoint + 'getallapprovals'),

  approvalsRules: Vue.resource(EndPoint + 'getallapprovalsrules{/id}'),

  disciplineRulesAPI: Vue.resource(EndPoint + 'discipline-rules{/id}'),

  approveLines: Vue.resource(EndPoint + 'approvalapproval'),

  lineApprovalRules: Vue.resource(EndPoint + 'lineapprovalrules'),

  objectsApprovalRules: Vue.resource(EndPoint + 'objectapprovalrules'),

  approvalsReport: Vue.resource(EndPoint + 'approvals-reports'),

  reportInfoEmployee: Vue.resource(EndPoint + 'report-info-employee'),

  holidaysReport: Vue.resource(EndPoint + 'holidays-report'),

  routineReport: Vue.resource(EndPoint + 'routines-report'),

  journeyReport: Vue.resource(EndPoint + 'journeys-report'),

  groupReport: Vue.resource(EndPoint + 'groups-report'),

  employerReport: Vue.resource(EndPoint + 'employers-report'),

  activityTypeReport: Vue.resource(EndPoint + 'activity-types-report'),

  activityCostCenterReport: Vue.resource(EndPoint + 'activity-cost-centers-report'),

  activityReport: Vue.resource(EndPoint + 'activity-objects-report'),

  company: Vue.resource(EndPoint + 'company{/id}'),

  companiesReport: Vue.resource(EndPoint + 'companies-report'),

  journey: Vue.resource(EndPoint + 'journey{/id}'),

  dayJourney: Vue.resource(EndPoint + 'dayjourney'),

  routine: Vue.resource(EndPoint + 'routine{/id}'),

  employer: Vue.resource(EndPoint + 'employer{/id}'),

  user: Vue.resource(EndPoint + 'user{/id}'),

  userGroup: Vue.resource(EndPoint + 'user-group{/id}'),

  userGroupTree: Vue.resource(EndPoint + 'user-group/tree'),

  activitysheet: Vue.resource(EndPoint + 'activitysheet{/kind}{/id}{/startDate}{/endDate}'),

  activitySum: Vue.resource(EndPoint + 'activity-sum'),

  employeesFunct: Vue.resource(EndPoint + 'employees-funct'),

  activityCostCenter: Vue.resource(EndPoint + 'activity-cost-center{/id}'),

  activityType: Vue.resource(EndPoint + 'activity-type{/id}{?fields?page}'),

  activityLine: Vue.resource(EndPoint + 'activity-line{/id}'),

  activity: Vue.resource(EndPoint + 'activity-object{/id}{?fields?page}'),

  fastRegister: Vue.resource(EndPoint + 'fast-register'),

  customRules: Vue.resource(EndPoint + 'custom{/id}'),

  whbRules: Vue.resource(EndPoint + 'work-hours-bank-rules{/id}'),

  sumtime: Vue.resource(EndPoint + 'sumtime{/id}{/year}{/month}'),

  arbssumtime: Vue.resource(EndPoint + 'sumarbtms{/id}{/year}{/month}'),

  sumtimesDefaults: Vue.resource(EndPoint + 'sumtimeui/defaults{/name}'),

  showselectorDisabled: Vue.resource(EndPoint + 'show_selector/disabled'),

  expectedCalcs: Vue.resource(EndPoint + 'expected-calcs{/id}{/calcId}'),

  timesheet: Vue.resource(EndPoint + 'timesheet-partial{/load}'),

  timesheetHash: Vue.resource(EndPoint + 'timesheet-partial/hash{/employee}{/year}{/month}'),

  timesheetGeneric: Vue.resource(EndPoint + 'timesheet-partial-generic'),

  timesheetPtInfo: Vue.resource(EndPoint + 'timesheet-partial-pt-info{/kind}{/id}'),

  groupComment: Vue.resource(EndPoint + 'todo-comment{/id}'),

  timesheetSync: Vue.resource(EndPoint + 'timesheet-partial-sync'),

  fakeTimelog: Vue.resource(EndPoint + 'fake-pt{/id}'),

  ignoreTimelog: Vue.resource(EndPoint + 'ignore-fake-pt{/id}'),

  line: Vue.resource(EndPoint + 'line{/id}'),

  lineJoin: Vue.resource(EndPoint + 'linejoiner'),

  reasons: Vue.resource(EndPoint + 'reason{/id}'),

  roleGroup: Vue.resource(EndPoint + 'rolegroup{/id}'),

  roleDetails: Vue.resource(EndPoint + 'role/details'),

  supervisor: Vue.resource(EndPoint + 'supervisor{/id}'),

  abstractJustify: Vue.resource(EndPoint + 'abstract-justify{/employeeId}{/typeId}{/year}{/month}{/day}'),

  showTimelog: Vue.resource(EndPoint + 'show-timelog', {}, {
    timeout: {
      method: 'POST',
      timeout: 20 * 1000
    }
  }),

  companyPosition: Vue.resource(EndPoint + 'company/{companyid}/position{/pid}'),

  companyPositionAll: Vue.resource(EndPoint + 'company/position'),

  companyPositionAttr: Vue.resource(EndPoint + 'company/position_attr'),

  companyPositionRule: Vue.resource(EndPoint + 'company/position/rule{/ruleId}'),

  companyPositionStatusDefault: Vue.resource(EndPoint + 'company/position/status'),

  companyPositionStatusPeriod: Vue.resource(EndPoint + 'company/position/status/{view}/period'),

  employeePositionMove: Vue.resource(EndPoint + 'mov-employee/employee{/employeeId}/position{/positionId}'),

  employeePositionMoveDefault: Vue.resource(EndPoint + 'mov-employee'),

  employeePositionMoveOverride: Vue.resource(EndPoint + 'mov-employee-over/employee{/employeeId}/position{/positionId}'),

  // employeePositionAvailableAll: Vue.resource(EndPoint + 'company/position/available-employee'),

  employeePositionAvailable: Vue.resource(EndPoint + 'company{/companyid}/position{/pid}/available-employee'),

  reason: Vue.resource(EndPoint + 'reason{/id}'),

  eventlog: Vue.resource(EndPoint + 'eventlog'),

  eventlogTypes: Vue.resource(EndPoint + 'eventlog/types'),

  eventlogSolve: Vue.resource(EndPoint + 'eventlog/solve{/eventlogId}'),

  eventlogEmployeeAbsence: Vue.resource(EndPoint + 'eventlog/employee/absence'),

  eventlogPositionUncovered: Vue.resource(EndPoint + 'eventlog/position/uncovered'),

  movementLog: Vue.resource(EndPoint + 'movelog{/movlogid}'),

  region: Vue.resource(EndPoint + 'region'),

  customFieldsEmployees: Vue.resource(EndPoint + 'employee-custom-fields'),

  changeMultipleDayjourney: Vue.resource(EndPoint + 'change-multiple-dayjourney'),

  doctorInfo: Vue.resource(EndPoint + 'doctor-info{/crm}'),

  dashboardExtraTime: Vue.resource(EndPoint + 'dashboard-extra-time'),

  dashboardSpecial: Vue.resource(EndPoint + 'dashboard-special'),

  dashboardWHB: Vue.resource(EndPoint + 'dashboard-whb'),

  twoWayLocker: Vue.resource(EndPoint + 'two-way-locker{/month}{/year}'),

  realTime: Vue.resource(EndPoint + 'real-time'),

  twoWayLockerNotifications: Vue.resource(EndPoint + 'two-way-locker/notifications'),

  unilateralLocker: Vue.resource(EndPoint + 'locker/unilateral'),

  unlocker: Vue.resource(EndPoint + 'unlocker'),

  twoWayLockerGetData: Vue.resource(EndPoint + 'two-way-locker/get-data{/month}{/year}'),

  twoWayLockerConfirmation: Vue.resource(EndPoint + 'two-way-locker-confirmation'),

  audit: Vue.resource(EndPoint + 'audit{/kind}{/id}'),

  folhaDiaria: Vue.resource(EndPoint.replace('/api', '') + 'folha_diaria'),

  folha: Vue.resource(EndPoint.replace('/api', '') + 'mostra-folha{/employeeId}{/companyId}{/year}{/month}{/just}{/showWorkHoursBank}{/showComments}'),

  alocReport: Vue.resource(EndPoint + 'generate-alocation-xls-report'),

  folhaWHB: Vue.resource(EndPoint.replace('/api', '') + 'mostra-folha-whb{/employeeId}{/companyId}{/year}{/month}{/just}/true'),

  whboCreate: Vue.resource(EndPoint + 'whbo{/kind}{/id}'),

  whboManager: Vue.resource(EndPoint + 'whb-manager{/kind}{/employeeId}{/startDate}{/endDate}'),

  whboManagerNew: Vue.resource(EndPoint + 'whb-manager-multiple-employees'),

  whbCloser: Vue.resource(EndPoint + 'whb-closer{/id}{/employeeId}{/date}{/dateBalance}'),

  whboAuth: Vue.resource(EndPoint + 'whb-auth{/whobId}{/approve}'),

  biometric: Vue.resource(EndPoint + 'biometric/management'),

  biometricApprove: Vue.resource(EndPoint + 'biometric/approve{/id}'),

  cids: Vue.resource(EndPoint + 'cids'),

  arbitraryTms: Vue.resource(EndPoint + 'arbtms{/id}'),

  arbitraryApprove: Vue.resource(EndPoint + 'arbtmsapprove'),

  arbitraryTmsNames: Vue.resource(EndPoint + 'arbtmsnames{/lineId}{/dayJourneyId}{/employeeId}'),

  autoCorrect: Vue.resource(EndPoint + 'autocorrect{/correct}{/refId}'),

  deviceManage: Vue.resource(EndPoint + 'management-comp-man'),

  approveDevices: Vue.resource(EndPoint + 'approve-devices'),

  devices: Vue.resource(EndPoint + 'devices'),

  closedPeriod: Vue.resource(EndPoint + 'closed-period{/id}{/month}{/year}'),

  workSchedule: Vue.resource(EndPoint + 'work-scheduler{/type}'),

  genEmpsDjs: Vue.resource(EndPoint + 'generate-employee-dayjourneys'),

  workScheduleReport: Vue.resource(EndPoint + 'work-scheduler-report'),

  authBlockUser: Vue.resource(EndPoint + 'block-user'),

  authUsersSessions: Vue.resource(EndPoint + 'auth-users-sessions'),

  authIpsBlackList: Vue.resource(EndPoint + 'auth-ips-blacklist{/kind}'),

  authSecurityEvents: Vue.resource(EndPoint + 'auth-security-events'),

  authCognitoForgotPassword: Vue.resource(EndPoint + 'auth-cognito-forgot-password'),

  confirmMigrationUserCognito: Vue.resource(EndPoint + 'auth-confirm-migration-user-cognito'),

  reprocessLinePts: Vue.resource(EndPoint + 'reproclinetls'),

  regrasDeNotificacao: Vue.resource(EndPoint + 'regras-de-notificacao{/id}'),

  httpResource: {
    patch: async (options) => {
      const {url, body, params} = options
      const respostaPatchApi = await Vue.http.patch(`${EndPoint}${url}`, {body, params})
      return respostaPatchApi
    }},

  notificationTypes: Vue.resource(EndPoint + 'notification-types'),

  notificationTypesEmployee: Vue.resource(EndPoint + 'notification-types-employee'),

  clearUserFile: Vue.resource(config.baseUrl + '/clear-user-file{/compManId}{/userId}'),

  reports: Vue.resource(EndPoint + 'user-file'),

  journeyOnCalls: Vue.resource(EndPoint + 'oncall{/id}{/djId}'),

  editTimelog: Vue.resource(EndPoint + 'edittimelog'),

  recalculateKind: Vue.resource(EndPoint + 'recalculatekind'),

  generateDeviceReport: Vue.resource(config.baseUrl + '/generate-status-report'),

  whbWindowManagement: Vue.resource(EndPoint + 'whb-window-management{/employeeId}'),

  whbCount: Vue.resource(EndPoint + 'whb-count'),

  timesheetVerify: Vue.resource(EndPoint + 'timesheet-verify'),

  usersReport: Vue.resource(EndPoint + 'generate-users-xls-report'),

  autoComplete: Vue.resource(EndPoint + 'auto-complete'),

  afastamento: Vue.resource(EndPoint + 'workjourney_folga{/employeeId}{/startDate}{/endDate}{/creatorId}{/journeyId}'),

  editarAfastamento: Vue.resource(EndPoint + 'workjourney_folga/set_end{/employeeId}{/endDate}{/creatorId}'),

  vacation: Vue.resource(EndPoint + 'vacation{/employeeId}{/startDate}{/endDate}'),

  authTerms: Vue.resource(EndPoint.replace('/api', '') + 'auth-terms{/date}{/employeeId}'),

  repModel: Vue.resource(EndPointREP + '/v2/rep/fields'),

  rep: Vue.resource(EndPointREP + '/v2/rep/{rep_id}'),

  pegaponto: Vue.resource(EndPointREP + '/v2/pegaponto/{pegaponto_id}'),

  reasonReport: Vue.resource(EndPoint + 'reason-report'),

  safeGetImages: Vue.resource(EndPoint + 'safe-get-images{/model}{/id}'),

  gerenciamentoDeArquivos: Vue.resource(EndPoint + 'aprovacao_de_arquivo{/id}'),

  aprovacaoIndividualDeArquivo: Vue.resource(EndPoint + 'aprovacao-individual{/id}{/acoes}'),

  demitirEmpregado: Vue.resource(EndPoint + 'demitir-empregado'),

  readmitirEmpregado: Vue.resource(EndPoint + 'readmitir-empregado'),

  criarGerenciamentoDeArquivo: async (parametros) => {
    const {
      descricao, dataLimitePedidoUtc, arquivo,
      categoriaId, acoesDeNotificacao,
      mensagemCustomizada, usuariosQueAprovarao,
      usuarioVinculado
    } = parametros

    const formData = new FormData()
    formData.append('descricao', descricao)
    formData.append('data_limite_pedido_utc', dataLimitePedidoUtc)
    formData.append('motivo_padrao_id', categoriaId)
    formData.append('acoes_de_notificacao', acoesDeNotificacao)
    formData.append('usuarios_que_aprovarao', usuariosQueAprovarao)
    formData.append('usuario_vinculado', usuarioVinculado)
    formData.append('arquivo_vindo_do_front', arquivo)
    formData.append('mensagem_customizada', mensagemCustomizada)

    const result = await Vue.resource(`${EndPoint}aprovacao_de_arquivo`).save(formData)
    return result
  },

  R01: Vue.resource(EndPoint.replace('/api', '') + 'comp_man_timelogsheet'),

  R02: Vue.resource(EndPoint.replace('/api', '') + 'comp_man_timelogsheet_whb'),

  R03: Vue.resource(EndPoint.replace('/api', '') + 'report_journey{/kind}'),

  R04: Vue.resource(EndPoint.replace('/api', '') + 'report_fah'),

  R05: Vue.resource(EndPoint.replace('/api', '') + 'export_default_apontamento_excel_compman'),

  R06: Vue.resource(EndPoint + 'generate-custom-report'),

  R07: Vue.resource(EndPoint + 'timelog-range-report'),

  R08: Vue.resource(EndPoint + 'reportpdf{/startDate}{/endDate}'),

  R09: Vue.resource(EndPoint + 'generate-timelogs-xls-report'),

  R10: Vue.resource(EndPoint + 'generate-whb-report'),

  R11: Vue.resource(EndPoint + 'weekday-divider-report'),

  R12: Vue.resource(EndPoint + 'report-punched{/reportType}'),

  R13: Vue.resource(EndPoint + 'report-info-employee'),

  R14: Vue.resource(EndPoint + 'generate-transfer-xls-report'),

  R15: Vue.resource(EndPoint + 'changes-report'),

  R16: Vue.resource(EndPoint + 'extra-time-report'),

  R17: Vue.resource(EndPoint + 'workjourney-folga-report'),

  R18: Vue.resource(EndPoint + 'benefits-report'),

  R19: Vue.resource(EndPoint + 'justifys-report'),

  R20: Vue.resource(EndPoint + 'timelog-company-location-report'),

  R21: Vue.resource(EndPoint + 'approve-whb-report'),

  R22: Vue.resource(EndPoint + 'ver-folhas-report'),

  R23: Vue.resource(EndPoint + 'activity-lines-report'),

  R24: Vue.resource(EndPoint + 'activity-sum-report'),

  R25: Vue.resource(EndPoint + 'recognize-face-spreadsheet'),

  R26: Vue.resource(EndPoint + 'on-call-spreadsheet'),

  R27: Vue.resource(EndPoint + 'absent-report'),

  R28: Vue.resource(EndPoint + 'whbcloser-report'),

  R29: Vue.resource(EndPoint + 'whb-management-report'),

  R30: Vue.resource(EndPoint + 'whb-daily-tracking-report'),

  R32: Vue.resource(EndPoint + 'situation-report'),

  R33: Vue.resource(EndPoint + 'manager-report'),

  R35: Vue.resource(EndPoint + 'acompanhamento-de-funcionarios-report'),

  R36: Vue.resource(EndPoint + 'relatorio-movimentacao-jornadas-escalas'),

  E01: Vue.resource(EndPoint.replace('/api', '') + 'export_script_ponto_compman'),

  E02: Vue.resource(EndPoint.replace('/api', '') + 'export_script_apontamento_compman'),

  E03: Vue.resource(EndPoint + 'export_whbe'),

  E04: Vue.resource(EndPoint + 'audio-extractor'),

  E05: Vue.resource(EndPoint + 'export_adf'),

  E06: Vue.resource(EndPoint + 'export_adft'),

  E07: Vue.resource(EndPoint + 'export_acjef'),

  E08: Vue.resource(EndPoint.replace('/api', '') + 'export_script_justify_compman'),

  E09: Vue.resource(EndPoint.replace('/api', '') + 'export_e09'),

  I01: Vue.resource(EndPoint + 'import-afd{/forceKind}'),

  I02: Vue.resource(EndPoint + 'import-escalas'),

  uploadFile: async (bucket, file, filename) => {
    const formData = new FormData()
    formData.append('file', file)

    const result = await Vue.resource(`${EndPoint}upload-file-to-bucket/${bucket}/${filename}`)
      .save(formData)
    return result
  },

  consultaIp: Vue.resource('https://us-central1-pontotel-tools.cloudfunctions.net/consultar-ip')
}
export const mixins = {
  methods: {
    $dispatchUseState: (useState, payload) => store.dispatch(useState, payload),
    $commitUseState: (useState, payload) => store.commit(useState, payload)
  }
}
Vue.mixin(mixins)

Vue.prototype.$API = API
Vue.prototype.$swal = swal
Vue.prototype.$hasPermission = hasPermission

export function wp (word) { return i18n.tc('words.' + word, 2) }
export function ws (word) { return i18n.tc('words.' + word, 1) }

Vue.prototype.$wp = wp // plural shorthand
Vue.prototype.$ws = ws // singular shorthand

Vue.prototype.$checkUserFiles = function () {
  this.$root.$emit('Notifications__checkUserFiles')
}
